import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const StickyHeaderTable = ({
  data,
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  columns,
  pagination = true,
}) => {
  const [gridView, setGridView] = useState(false);
  const theme = useTheme();

  // const handleView = () => {
  //   setGridView(true);
  // };

  // const handleListView = () => {
  //   setGridView(false);
  // };

  return (
    <>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <IconButton
        // onClick={handleListView}
        >
          <ViewList />
        </IconButton>
        <IconButton
        // onClick={handleView}
        >
          <ViewModule />
        </IconButton>
      </div> */}
      {!gridView ? (
        <TableContainer
          sx={{
            mx: 2,
            mb: 1,
            maxHeight: 500,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 2,
            overflow: "auto",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              tableLayout: "fixed",
              width: "100%",
            }}
          >
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align || "left"}
                    sx={{
                      minWidth: column.minWidth,
                      width: column.width,
                      px: 2,
                      py: 1.5,
                      fontWeight: 700,
                      fontSize: "0.875rem",
                      backgroundColor: "background.paper",
                      borderBottom: "1px solid",
                      borderColor: "divider",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((row, index) => (
                <TableRow
                  hover
                  key={row.id || index}
                  sx={{
                    "&:last-child td": {
                      borderBottom: 0,
                    },
                  }}
                >
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align || "left"}
                      sx={{
                        px: 2,
                        py: 1.5,
                        verticalAlign: "middle",
                        width: column.width,
                        borderColor: "divider",
                        overflow: "hidden",
                      }}
                    >
                      {column.render
                        ? column.render(row)
                        : column.format
                        ? column.format(row[column.id])
                        : row[column.id]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Grid container p={2} spacing={2}>
          {data.map((row, index) => (
            <Grid item xs={12} sm={6} md={3} key={row.id || index}>
              <Box
                p={2}
                border={1}
                borderRadius={4}
                height="100%"
                width="100%"
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                sx={{
                  background:
                    theme.palette.mode === "dark"
                      ? theme.palette.dark.main
                      : theme.palette.grey[50],
                  border:
                    theme.palette.mode === "dark"
                      ? "1px solid transparent"
                      : `1px solid ${theme.palette.grey[100]}`,
                  "&:hover": { borderColor: theme.palette.primary.main },
                }}
              >
                <div>
                  {columns.map((column) => (
                    <div
                      key={column.id}
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="title" component="strong">
                        {column.label}:
                      </Typography>
                      <Typography variant="subtitle">
                        {column.render
                          ? column.render(row)
                          : column.format
                          ? column.format(row[column.id])
                          : row[column.id]}
                      </Typography>
                    </div>
                  ))}
                </div>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
      {pagination && (
        <Box
          sx={{
            mx: 2,
            display: "flex",
            justifyContent: "flex-end",
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          <TablePagination
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default StickyHeaderTable;
